import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e5075a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_datacollect" }
const _hoisted_2 = { class: "left_panel" }
const _hoisted_3 = { class: "panel_header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "数据收集模板", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_6 = { class: "template_list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "template_name" }
const _hoisted_9 = { class: "template_info" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("隐私信息收集")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("公开模板")
const _hoisted_12 = { class: "template_actions" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("批量创建")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_16 = {
  key: 0,
  class: "no_data"
}
const _hoisted_17 = { class: "right_panel" }
const _hoisted_18 = {
  key: 0,
  class: "field_config"
}
const _hoisted_19 = { class: "panel_header" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("添加字段")
const _hoisted_21 = { class: "field_list" }
const _hoisted_22 = { class: "field_card_header" }
const _hoisted_23 = { class: "field_order" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_26 = { class: "field_card_body" }
const _hoisted_27 = { class: "field_info_row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "数据类型：", -1))
const _hoisted_29 = {
  key: 0,
  class: "field_info_row"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "下拉选项：", -1))
const _hoisted_31 = {
  key: 1,
  class: "field_info_row"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "SQL 语句：", -1))
const _hoisted_33 = { class: "sql_text" }
const _hoisted_34 = { class: "field_info_row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "可编辑用户：", -1))
const _hoisted_36 = {
  key: 0,
  style: {"color":"#909399"}
}
const _hoisted_37 = {
  key: 0,
  class: "no_data"
}
const _hoisted_38 = {
  key: 1,
  class: "no_select"
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode("公开模板")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("隐私信息收集")
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","margin-top":"4px","color":"#909399","font-size":"12px"} }, " 隐私信息收集：收集的数据仅\"下一道填写人\"和管理员可见 ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","color":"#999","margin-top":"4px"} }, " 名单内的人员可将\"下一道填写人\"选为\"无（信息已完善）\"，名单外的人员必须指定具体填写人；不选择任何人员表示所有人可选\"无\" ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"15px"} }, null, -1))
const _hoisted_44 = { class: "flexCenter" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"10px","color":"#606266","font-size":"13px"} }, " 勾选需要为其创建信息收集的用户（每个用户生成一条待其填写的数据）： ", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"15px"} }, null, -1))
const _hoisted_49 = { class: "flexCenter" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("确 定 创 建")
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#909399","font-size":"12px","margin-top":"4px"} }, "返回结果的第一列作为值，第二列作为显示文本（仅支持 SELECT）", -1))
const _hoisted_53 = { style: {"width":"100%"} }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("+ 添加选项")
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"12px","color":"#999","margin-top":"4px"} }, "不选择任何用户表示所有人可编辑", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"15px"} }, null, -1))
const _hoisted_57 = { class: "flexCenter" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_59 = /*#__PURE__*/_createTextVNode("确 定")

import { ref, onMounted } from 'vue';
	import { ElMessage, ElMessageBox } from 'element-plus';
	import { CirclePlus, Delete } from '@element-plus/icons-vue';
	import { requestAllUser } from '@/api/api';
	import {
		reqDataCollectTemplateList,
		reqDataCollectTemplateEdit,
		reqDataCollectTemplateDelete,
		reqDataCollectFieldList,
		reqDataCollectFieldEdit,
		reqDataCollectFieldDelete,
		reqDataCollectBatchCreateData
	} from '@/api/datacollectApi';

	// 所有人员
	
export default /*#__PURE__*/_defineComponent({
  name: 'DataCollectTemplate',
  setup(__props) {

	const allUserList = ref<any[]>([]);
	// 模板列表
	const templateList = ref<any[]>([]);
	// 当前选中的模板
	const currentTemplateId = ref<number>(0);
	const currentTemplateName = ref<string>('');
	// 字段列表
	const fieldList = ref<any[]>([]);

	// 模板弹窗
	const templateDialogShow = ref(false);
	const templateDialogTitle = ref('新增模板');
	const templateForm = ref<any>({ id: 0, name: '', type1: 1, complete_users: '' });
	// 可选"无（信息已完善）"的人员名单
	const templateCompleteUsers = ref<string[]>([]);

	// 隐私信息收集：批量给哪些用户创建
	const batchUserDialogShow = ref(false);
	const batchSelectedUsers = ref<string[]>([]);
	const batchAllChecked = ref(false);
	const batchIndeterminate = ref(false);

	const openBatchCreate = (row: any) => {
		currentTemplateId.value = row.id;
		currentTemplateName.value = row.name;
		batchSelectedUsers.value = [];
		batchAllChecked.value = false;
		batchIndeterminate.value = false;
		batchUserDialogShow.value = true;
	};

	const handleBatchCheckAll = (val: any) => {
		batchSelectedUsers.value = val ? allUserList.value.map((u: any) => u.name) : [];
		batchIndeterminate.value = false;
	};

	const handleBatchUsersChange = (value: any) => {
		const checkedCount = value.length;
		batchAllChecked.value = checkedCount === allUserList.value.length;
		batchIndeterminate.value = checkedCount > 0 && checkedCount < allUserList.value.length;
	};

	const submitBatchCreate = () => {
		if (batchSelectedUsers.value.length === 0) {
			ElMessage.warning('请选择要创建的用户');
			return;
		}
		reqDataCollectBatchCreateData({
			templateid: currentTemplateId.value,
			users: batchSelectedUsers.value.join(',')
		}).then((res: any) => {
			if (res.status === 1) {
				ElMessage.success(res.msg || '创建成功');
				batchUserDialogShow.value = false;
			} else {
				ElMessage.error(res.msg || '创建失败');
			}
		});
	};

	// 字段弹窗
	const fieldDialogShow = ref(false);
	const fieldDialogTitle = ref('添加字段');
	const fieldForm = ref<any>({
		id: 0,
		templateid: 0,
		fieldname: '',
		fieldtype: 'text',
		fieldoptions: '',
		sql: '',
		fieldorder: 0,
		editableusers: ''
	});
	const fieldOptionsList = ref<string[]>([]);
	const fieldEditableUsers = ref<string[]>([]);

	onMounted(() => {
		loadTemplateList();
		loadAllUser();
	});

	const loadAllUser = () => {
		requestAllUser().then((res: any) => {
			if (res.status === 1) {
				allUserList.value = res.datalist || [];
			}
		});
	};

	const loadTemplateList = () => {
		reqDataCollectTemplateList({ pageSize: 100, pageIndex: 1 }).then((res: any) => {
			if (res.code === 0 || res.data) {
				const data = res.data || res.DataMap || [];
				templateList.value = data.map((item: any) => ({
					cell: item.cell || item
				}));
			}
		});
	};

	const selectTemplate = (item: any) => {
		currentTemplateId.value = item.cell.id;
		currentTemplateName.value = item.cell.name;
		loadFieldList();
	};

	const loadFieldList = () => {
		if (currentTemplateId.value > 0) {
			reqDataCollectFieldList({ templateid: currentTemplateId.value }).then((res: any) => {
				if (res.status === 1) {
					fieldList.value = res.datalist || [];
				}
			});
		}
	};

	// === 模板操作 ===
	const addTemplate = () => {
		templateDialogTitle.value = '新增模板';
		templateForm.value = { id: 0, name: '', type1: 1, complete_users: '' };
		templateCompleteUsers.value = [];
		templateDialogShow.value = true;
	};

	const editTemplate = (item: any) => {
		templateDialogTitle.value = '编辑模板';
		templateForm.value = { id: item.cell.id, name: item.cell.name, type1: item.cell.type1 || 1, complete_users: item.cell.complete_users || '' };
		templateCompleteUsers.value = item.cell.complete_users ? item.cell.complete_users.split(',').map((u: string) => u.trim()).filter((u: string) => u) : [];
		templateDialogShow.value = true;
	};

	const deleteTemplate = (item: any) => {
		ElMessageBox.confirm('确定要删除该模板吗？删除后关联的字段配置也将被清除。', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			reqDataCollectTemplateDelete({ id: item.cell.id }).then((res: any) => {
				if (res.status === 1) {
					ElMessage({ message: '删除成功', type: 'success', duration: 500 });
					if (currentTemplateId.value === item.cell.id) {
						currentTemplateId.value = 0;
						currentTemplateName.value = '';
						fieldList.value = [];
					}
					loadTemplateList();
				}
			});
		}).catch(() => {});
	};

	const submitTemplate = () => {
		if (!templateForm.value.name) {
			ElMessage.warning('请输入模板名称');
			return;
		}
		reqDataCollectTemplateEdit({
			id: templateForm.value.id,
			name: templateForm.value.name,
			type1: templateForm.value.type1,
			complete_users: templateCompleteUsers.value.join(',')
		}).then((res: any) => {
			if (res.status === 1) {
				ElMessage({ message: '操作成功', type: 'success', duration: 500 });
				templateDialogShow.value = false;
				loadTemplateList();
				if (templateForm.value.id === 0 && res.datalist) {
					currentTemplateId.value = res.datalist;
					currentTemplateName.value = templateForm.value.name;
					loadFieldList();
				}
			} else {
				ElMessage({ message: res.msg || '操作失败', type: 'error', duration: 500 });
			}
		});
	};

	// === 字段操作 ===
	const addField = () => {
		fieldDialogTitle.value = '添加字段';
		fieldForm.value = {
			id: 0,
			templateid: currentTemplateId.value,
			fieldname: '',
			fieldtype: 'text',
			fieldoptions: '',
			sql: '',
			fieldorder: fieldList.value.length,
			editableusers: ''
			};
			fieldOptionsList.value = [];
			fieldEditableUsers.value = [];
			fieldDialogShow.value = true;
			};

	const editField = (field: any) => {
		fieldDialogTitle.value = '编辑字段';
		fieldForm.value = {
			id: field.id,
			templateid: field.templateid,
			fieldname: field.fieldname,
			fieldtype: field.fieldtype || 'text',
			fieldoptions: field.fieldoptions || '',
			sql: field.fieldtype === 'dblist' ? (field.fieldoptions || '') : '',
			fieldorder: field.fieldorder || 0,
			editableusers: field.editableusers || ''
		};
		// 解析下拉选项
		fieldOptionsList.value = parseOptions(field.fieldoptions);
		// 解析可编辑用户
		fieldEditableUsers.value = field.editableusers ? field.editableusers.split(',').filter((u: string) => u) : [];
		fieldDialogShow.value = true;
	};

	const deleteField = (field: any) => {
		ElMessageBox.confirm('确定要删除该字段吗？', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			reqDataCollectFieldDelete({ id: field.id }).then((res: any) => {
				if (res.status === 1) {
					ElMessage({ message: '删除成功', type: 'success', duration: 500 });
					loadFieldList();
				}
			});
		}).catch(() => {});
	};

	const submitField = () => {
		if (!fieldForm.value.fieldname) {
			ElMessage.warning('请输入字段名称');
			return;
		}
		// 组装下拉选项JSON
		let optionsJson = '';
		if (fieldForm.value.fieldtype === 'select') {
			optionsJson = JSON.stringify(fieldOptionsList.value.filter((o: string) => o.trim()));
		} else if (fieldForm.value.fieldtype === 'dblist') {
			// 数据库来源的下拉选择：将 SQL 语句直接存入 fieldoptions
			if (!fieldForm.value.sql || !fieldForm.value.sql.trim()) {
				ElMessage.warning('请输入 SQL 语句');
				return;
			}
			optionsJson = fieldForm.value.sql.trim();
		}
		// 组装可编辑用户
		let editableUsersStr = fieldEditableUsers.value.join(',');

		reqDataCollectFieldEdit({
			id: fieldForm.value.id,
			templateid: fieldForm.value.templateid,
			fieldname: fieldForm.value.fieldname,
			fieldtype: fieldForm.value.fieldtype,
			fieldoptions: optionsJson,
			fieldorder: fieldForm.value.fieldorder,
			editableusers: editableUsersStr
		}).then((res: any) => {
			if (res.status === 1) {
				ElMessage({ message: '操作成功', type: 'success', duration: 500 });
				fieldDialogShow.value = false;
				loadFieldList();
			} else {
				ElMessage({ message: res.msg || '操作失败', type: 'error', duration: 500 });
			}
		});
	};

	// === 下拉选项操作 ===
	const addOption = () => {
		fieldOptionsList.value.push('');
	};

	const removeOption = (index: number) => {
		fieldOptionsList.value.splice(index, 1);
	};

	// === 工具函数 ===
	const fieldTypeLabel = (type: string) => {
		const map: any = { text: '文本', textarea: '多行文本', select: '下拉选择', dblist: '数据库来源的下拉选择', date: '日期', attachment: '附件' };
		return map[type] || type;
	};

	const fieldTypeTagType = (type: string) => {
		const map: any = { text: 'primary', textarea: '', select: 'success', dblist: 'warning', date: 'warning', attachment: 'info' };
		return map[type] || 'primary';
	};

	// 判断字段是否为“数据库来源的下拉选择”
	const isDbList = (field: any) => field.fieldtype === 'dblist';

	const parseOptions = (optionsStr: string): string[] => {
		if (!optionsStr) return [];
		try {
			const arr = JSON.parse(optionsStr);
			return Array.isArray(arr) ? arr : [];
		} catch (e) {
			return [];
		}
	};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: addTemplate,
          icon: _unref(CirclePlus)
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["icon"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["template_item", {active: currentTemplateId.value === item.cell.id}]),
            onClick: ($event: any) => (selectTemplate(item))
          }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.cell.name), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", null, "创建人：" + _toDisplayString(item.cell.createname), 1),
              (item.cell.type1 == 2)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "warning",
                    size: "small",
                    style: {"margin-left":"6px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "success",
                    size: "small",
                    style: {"margin-left":"6px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  })),
              (item.cell.complete_users)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 2,
                    type: "danger",
                    size: "small",
                    style: {"margin-left":"6px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.cell.complete_users.split(',').length) + "人可选无 ", 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_button, {
                type: "primary",
                link: "",
                size: "small",
                onClick: _withModifiers(($event: any) => (editTemplate(item)), ["stop"])
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 2
              }, 1032, ["onClick"]),
              (item.cell.type1 == 2)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "warning",
                    link: "",
                    size: "small",
                    onClick: _withModifiers(($event: any) => (openBatchCreate(item.cell)), ["stop"])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "danger",
                link: "",
                size: "small",
                onClick: _withModifiers(($event: any) => (deleteTemplate(item)), ["stop"])
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ], 10, _hoisted_7))
        }), 128)),
        (templateList.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, "暂无数据，请点击新增"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      (currentTemplateId.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", null, _toDisplayString(currentTemplateName.value) + " - 字段配置", 1),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: addField,
                icon: _unref(CirclePlus)
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }, 8, ["icon"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldList.value, (field, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "field_card"
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(index + 1) + ". " + _toDisplayString(field.fieldname), 1),
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        link: "",
                        size: "small",
                        onClick: ($event: any) => (editField(field))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_24
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "danger",
                        link: "",
                        size: "small",
                        onClick: ($event: any) => (deleteField(field))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_25
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createVNode(_component_el_tag, {
                        type: fieldTypeTagType(field.fieldtype),
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(fieldTypeLabel(field.fieldtype)), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ]),
                    (field.fieldtype==='select' && field.fieldoptions)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _hoisted_30,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseOptions(field.fieldoptions), (opt, oi) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: oi,
                              size: "small",
                              style: {"margin-right":"4px","margin-bottom":"4px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(opt), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (isDbList(field) && field.fieldoptions)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("span", _hoisted_33, _toDisplayString(field.fieldoptions), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      (!field.editableusers)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, "所有人可编辑"))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(field.editableusers.split(','), (u, ui) => {
                            return (_openBlock(), _createBlock(_component_el_tag, {
                              key: ui,
                              size: "small",
                              type: "info",
                              style: {"margin-right":"4px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(u), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                    ])
                  ])
                ]))
              }), 128)),
              (fieldList.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, "暂无字段，请点击添加"))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_38, "请先选择或新增一个数据收集模板"))
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: templateDialogShow.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((templateDialogShow).value = $event)),
      title: templateDialogTitle.value,
      "show-close": false,
      "close-on-click-modal": false,
      width: "450px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "100px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "模板名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: templateForm.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((templateForm.value.name) = $event)),
                  placeholder: "请输入模板名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "模板类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: templateForm.value.type1,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((templateForm.value.type1) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      label: 1,
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_39
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      label: 2,
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_40
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_41
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "可选无人员" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: templateCompleteUsers.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((templateCompleteUsers).value = $event)),
                  multiple: "",
                  filterable: "",
                  placeholder: "请选择允许选'无（信息已完善）'的人员",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allUserList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.name,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_42
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_43,
        _createElementVNode("div", _hoisted_44, [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (templateDialogShow.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_45
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitTemplate
          }, {
            default: _withCtx(() => [
              _hoisted_46
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: batchUserDialogShow.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((batchUserDialogShow).value = $event)),
      title: currentTemplateName.value + ' - 批量创建信息收集',
      "show-close": false,
      "close-on-click-modal": false,
      width: "520px"
    }, {
      default: _withCtx(() => [
        _hoisted_47,
        _createVNode(_component_el_checkbox, {
          modelValue: batchAllChecked.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((batchAllChecked).value = $event)),
          indeterminate: batchIndeterminate.value,
          onChange: handleBatchCheckAll
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 全选（" + _toDisplayString(allUserList.value.length) + " 人） ", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "indeterminate"]),
        _createVNode(_component_el_divider, { style: {"margin":"12px 0"} }),
        _createVNode(_component_el_checkbox_group, {
          modelValue: batchSelectedUsers.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((batchSelectedUsers).value = $event)),
          onChange: handleBatchUsersChange,
          style: {"display":"flex","flex-wrap":"wrap","gap":"8px 16px","max-height":"300px","overflow":"auto"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allUserList.value, (u, ui) => {
              return (_openBlock(), _createBlock(_component_el_checkbox, {
                key: ui,
                value: u.name,
                label: u.name
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(u.name), 1)
                ]),
                _: 2
              }, 1032, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _hoisted_48,
        _createElementVNode("div", _hoisted_49, [
          _createVNode(_component_el_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (batchUserDialogShow.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_50
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitBatchCreate
          }, {
            default: _withCtx(() => [
              _hoisted_51
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: fieldDialogShow.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((fieldDialogShow).value = $event)),
      title: fieldDialogTitle.value,
      "show-close": false,
      "close-on-click-modal": false,
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "120px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "字段名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fieldForm.value.fieldname,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((fieldForm.value.fieldname) = $event)),
                  placeholder: "请输入字段名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "数据类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: fieldForm.value.fieldtype,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((fieldForm.value.fieldtype) = $event)),
                  placeholder: "请选择数据类型",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "文本",
                      value: "text"
                    }),
                    _createVNode(_component_el_option, {
                      label: "多行文本",
                      value: "textarea"
                    }),
                    _createVNode(_component_el_option, {
                      label: "下拉选择",
                      value: "select"
                    }),
                    _createVNode(_component_el_option, {
                      label: "数据库来源的下拉选择",
                      value: "dblist"
                    }),
                    _createVNode(_component_el_option, {
                      label: "日期",
                      value: "date"
                    }),
                    _createVNode(_component_el_option, {
                      label: "附件",
                      value: "attachment"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (fieldForm.value.fieldtype==='dblist')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "SQL 语句"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: fieldForm.value.sql,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((fieldForm.value.sql) = $event)),
                      type: "textarea",
                      rows: 3,
                      placeholder: "请输入查询 SQL，如：select code, name from table1"
                    }, null, 8, ["modelValue"]),
                    _hoisted_52
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (fieldForm.value.fieldtype==='select')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "下拉选项"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_53, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldOptionsList.value, (opt, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          style: {"display":"flex","margin-bottom":"6px","align-items":"center"}
                        }, [
                          _createVNode(_component_el_input, {
                            modelValue: fieldOptionsList.value[index],
                            "onUpdate:modelValue": ($event: any) => ((fieldOptionsList.value[index]) = $event),
                            placeholder: "请输入选项",
                            style: {"flex":"1","margin-right":"8px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_el_button, {
                            type: "danger",
                            size: "small",
                            icon: _unref(Delete),
                            circle: "",
                            onClick: ($event: any) => (removeOption(index))
                          }, null, 8, ["icon", "onClick"])
                        ]))
                      }), 128)),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        link: "",
                        onClick: addOption
                      }, {
                        default: _withCtx(() => [
                          _hoisted_54
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "排序序号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: fieldForm.value.fieldorder,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((fieldForm.value.fieldorder) = $event)),
                  min: 0,
                  max: 999
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "可编辑用户" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: fieldEditableUsers.value,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((fieldEditableUsers).value = $event)),
                  multiple: "",
                  filterable: "",
                  placeholder: "不选则所有人可编辑",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allUserList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.name,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_55
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_56,
        _createElementVNode("div", _hoisted_57, [
          _createVNode(_component_el_button, {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (fieldDialogShow.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_58
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitField
          }, {
            default: _withCtx(() => [
              _hoisted_59
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})